/** Greeting first name; single-word and email-style names pass through unmangled. */
export function getFirstName(fullName: string | null | undefined): string {
	const trimmed = fullName?.trim() ?? "";
	const [first] = trimmed.split(/\s+/);
	return first || trimmed;
}
